/**
 * EU-27 Laendercodes (ISO-3166-1 alpha-2) — Issue #322 (Follow-up #318).
 *
 * Auf die 27 EU-Mitgliedsstaaten eingedampft (Owner-Vorgabe: alle Nicht-EU-Laender
 * raus). EEA/EFTA (CH, NO, IS, LI) und UK sind bewusst NICHT enthalten.
 *
 * Anzeigenamen werden zur Laufzeit ueber `Intl.DisplayNames` lokalisiert (de/en),
 * statt eine handgepflegte Namensliste pro Sprache zu fuehren — die Codeliste ist
 * die einzige Quelle, die Namen liefert die Plattform.
 */
export const EU_27_ALPHA2: readonly string[] = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
  'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
];

/** Lokalisierter Laendername fuer einen Code; faellt bei Bedarf auf den Code zurueck. */
export function countryDisplayName(code: string, lang: string): string {
  try {
    const dn = new Intl.DisplayNames([lang], { type: 'region' });
    return dn.of(code.toUpperCase()) ?? code;
  } catch {
    return code;
  }
}

export interface CountryOption {
  code: string;
  name: string;
}

/** Alphabetisch (nach lokalisiertem Namen) sortierte Laenderliste fuer Selects. */
export function getCountryOptions(lang: string): CountryOption[] {
  return EU_27_ALPHA2.map((code) => ({ code, name: countryDisplayName(code, lang) })).sort(
    (a, b) => a.name.localeCompare(b.name, lang),
  );
}
